import utils from 'utils';

let className = '';

export const removeExpandedClass = cls =>
  document
    .getElementsByClassName(cls)
    .item(0)
    ?.classList.remove('expanded');

export const setPreviousAriaDrawerTags = (el, isOpening, isExapnded) => {
  const controls = document.querySelector(`[aria-controls="${el}"]`);
  controls && controls?.nextElementSibling?.setAttribute('aria-hidden', isOpening);
  controls && controls.setAttribute('aria-expanded', isExapnded);
  localStorage.removeItem('isPreviousSubMenuOpenId');
  return el;
};

export default {
  init(store, domEl) {
    const button = domEl.getElementsByTagName('button')[0];
    const headerWrapper = document.querySelector('.headerWrapper');
    const overlayClass = 'show-overlay';

    function close() {
      domEl.classList.remove('expanded');
      document.removeEventListener('click', close);
      button.setAttribute('aria-expanded', false);
      headerWrapper.classList.contains(overlayClass) && headerWrapper.classList.remove(overlayClass); // Remove the overlay class on the headerWrapper
    }
    button.onclick = e => {
      const helpToggleButton =
        e.srcElement.parentNode.previousElementSibling || e.srcElement.parentNode?.nextElementSibling;
      if (className.length > 0 && className === domEl.classList.value) {
        return removeExpandedClass(className);
      }
      const getPreviousOpenMenuIds = localStorage.getItem('isPreviousSubMenuOpenId');
      getPreviousOpenMenuIds && setPreviousAriaDrawerTags(getPreviousOpenMenuIds, true, false);
      document
        .getElementsByClassName(className)
        .item(0)
        ?.classList.remove('expanded');
      // removing previously openend nav
      helpToggleButton &&
        helpToggleButton.classList.contains('expanded') &&
        helpToggleButton.classList.remove('expanded');

      className = '';
      if (!domEl.classList.contains('expanded')) {
        button.setAttribute('aria-expanded', true);
        domEl.classList.add('expanded');
        className = domEl.classList.value;
        const closestNav = button?.closest('nav');
        const subMenuElExpanded = closestNav?.classList?.contains('expanded');

        const allTabbableMenuItems =
          subMenuElExpanded && utils.accessibility.findTabbableDescendants(closestNav, false);
        allTabbableMenuItems[allTabbableMenuItems.indexOf(e.target) + 1].focus();

        utils.analytics.interaction('menu', 'nav', button.innerText.toLowerCase());
        window.innerWidth > 1279 && headerWrapper.classList.add(overlayClass); // Add the overlay class on the headerWrapper
        document.addEventListener('click', close);
        e.stopImmediatePropagation(); // Prevents the addEventListener handler from firing immediately after being assigned due to bubbling
      }
      return null;
    };
  },
};
